export default {
  carregarRodape(state, payload) {
    state.empresarodape = payload;
  },
  setBanners(state, payload) {
    state.banners = payload;
  },
  setarBanners(state, payload) {
    state.banners = payload;
  },
  setarFiliais(state, payload) {
    state.filiais = payload;
  },
  setarVendedores(state, payload) {
    state.vendedores = payload;
  },
  setarGlobal(state, payload) {
    state.global = payload;
  },
  setarPermissaoUsuario(state, payload) {
    state.permissaoUsuario = payload;
  },
  setarMostrarEstoque(state, payload) {
    state.mostrarEstoque = payload;
  },
};
